






















import settings from '@/settings'
import n from '@/utils/notifications'
import menus from '@/components/menus'
import ages_pyramid from '@/components/collaborators_charts/ages_pyramid'
import pie_chart from '@/components/collaborators_charts/pie_chart'

export default {
    name: 'company_stats'

    components: {
        menus, ages_pyramid, pie_chart
    }

    data: ()->
        ages_pyramid_datas: {}
        job_levels_datas: []
        job_levels_detail: ''
        job_status_datas: []
        job_status_detail: ''
        rqths_datas: []
        rqths_detail: ''
        job_contract_types_datas: []
        job_contract_types_detail: ''

    beforeMount: ()->
        # console.log "COLLABORATORS CHARTS MOUNTED"
        self = @
        @$http.post(settings.users_stats, {"company_uid": @$store.getters.current_company.uid})
        .then (resp)->
            if resp.body.status == "ok"
                # console.log "GET USERS STATS", resp.body.datas
                self.ages_pyramid_datas = resp.body.datas.pyramid

                job_status_datas = []
                for k,v of resp.body.datas.status.data
                    job_status_datas.push({name:k, y:v})
                self.job_status_datas = job_status_datas
                self.job_status_detail = "sur "+resp.body.datas.status.count+" contrats courants"

                job_levels_datas = []
                for k,v of resp.body.datas.levels.data
                    job_levels_datas.push({name:k, y:v})
                self.job_levels_datas = job_levels_datas
                self.job_levels_detail = "sur "+resp.body.datas.levels.count+" valeurs connues"

                job_contract_types_datas = []
                for k,v of resp.body.datas.contracts.data
                    job_contract_types_datas.push({name:k, y:v})
                self.job_contract_types_datas = job_contract_types_datas
                self.job_contract_types_detail = "sur "+resp.body.datas.contracts.count+" contrats courants"

                rqths_datas = []
                for k,v of resp.body.datas.rqths.data
                    rqths_datas.push({name:k, y:v})
                self.rqths_datas = rqths_datas
                self.rqths_detail = "sur "+resp.body.datas.rqths.count+" valeurs connues"
            else
                n.error("company_stats: beforeMount: then", resp.body.message)
}
